import {Form, Formik} from 'formik';
import {Grid} from '@mui/material';

import CustomButton from './CustomButton';
import validationSchema from './Validation';
import RequiredFields from './fields/RequiredFields';
import OptionalFields from './fields/OptionalFields';

const AddOrEditPatient = ({
  requiredFields,
  activeStep,
  disabled,
  type,
  data,
  actionHandler,
}) => {
  const initialValues =
    type === 'edit'
      ? {
          firstName: data?.firstName,
          lastName: data?.lastName,
          phoneNumber: data?.phoneNumber,
          insulinType: data?.insulinType,
          isMale: data?.isMale,
          birthDate: data?.birthDate,
          yearsWithDiabet: data?.yearsWithDiabet,
          isUsingOralMedications: data?.isUsingOralMedications,
          diabetType: data?.diabetType,
          isPregnant: data?.isPregnant,

        }
      : {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          insulinType: null,
          isMale: null,
          birthDate: null,
          yearsWithDiabet: null,
          isUsingOralMedications: null,
          diabetType: null,
          isPregnant: null,

        };

  const handleSubmit = (values) => {
      const Data = {
          ...values,
          isPregnant: values?.isMale===false?JSON.parse(values?.isPregnant):false,
      }
    if (type === 'add') {
      actionHandler(Data, false);
    } else {
      actionHandler(Data);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}>
      {(props) => (
        <Form>
          <Grid container spacing={'14px'}>
            {type === 'add' ? (
              <>
                {requiredFields ? (
                  <RequiredFields {...props} type={type} />
                ) : (
                  <OptionalFields {...props} />
                )}
              </>
            ) : (
              <>
                <RequiredFields {...props} type={type} />
                <OptionalFields {...props} />
              </>
            )}
          </Grid>
          <CustomButton
            activeStep={activeStep}
            disabled={disabled}
            type={type}
          />
        </Form>
      )}
    </Formik>
  );
};

export default AddOrEditPatient;
